import { RADEnvironmentProxy } from 'radpresentation.htmlclient.defaultviewextensions';

// PDO-Typ und Operationsname des serverseitigen Startseiten-Hinweis-Endpunkts.
const NEWCOMER_PD_TYPE   = 'ONV.ONV.Newcomer';
const OP_STARTPAGE_HINTS = 'GetStartpageNewcomerHints';

/**
 * Hinweis-Kennzahlen der Startseite fuer den aktuellen Mandanten
 * (Backend-Kontrakt, siehe StartpageHintsDto).
 */
export interface IStartpageHints {
    /** Unbeantwortete, aktuelle Newcomer (nicht beantwortet, nicht archiviert, nicht lizensiert). */
    unansweredNewcomers:    number;
    /** Aktuelle Newcomer ohne Kurszuordnung, die kein Selbststudium gewählt haben. */
    newcomersWithoutCourse: number;
}

/**
 * Ruft die Startseiten-Hinweis-Kennzahlen des aktuellen Mandanten ab. Die Abfrage
 * folgt serverseitig dem Principal-Filter (eigener Landesverband), daher werden
 * keine Parameter benoetigt.
 */
export function fetchStartpageHints(): JQueryPromise<IStartpageHints | null> {
    return RADEnvironmentProxy.getInstance().callStaticOperation({
        pdTypeName:          NEWCOMER_PD_TYPE,
        operationName:       OP_STARTPAGE_HINTS,
        operationParameters: [],
        contextParameters:   {},
    }).then((result) => parseStartpageHints(result?.returnValue));
}

/**
 * Normalisiert den Rueckgabewert der Operation. <c>returnValue</c> ist je nach
 * Serialisierung bereits ein Objekt oder ein JSON-String.
 */
export function parseStartpageHints(returnValue: unknown): IStartpageHints | null {
    let raw: unknown = returnValue;

    if (typeof raw === 'string') {
        try { raw = JSON.parse(raw); }
        catch { return null; }
    }

    if (raw == null || typeof raw !== 'object') return null;
    const obj = raw as Partial<IStartpageHints>;
    if (typeof obj.unansweredNewcomers !== 'number' || typeof obj.newcomersWithoutCourse !== 'number') {
        return null;
    }
    return obj as IStartpageHints;
}
